<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Portadas - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         
                <b-col sm="12" md="8">
                 
                </b-col>

                <b-col sm="12" md="3">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input @keyup.enter="ListCoverPage" v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListCoverPage"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('CoverPageAdd')" class="btn form-control btn-primary"  :to="{ path: '/portada/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="10%" class="text-center">Imagen</th>
                    <th width="67%" class="text-center">Nombre</th>
                    <th width="10%" class="text-center">Estado</th>
                    <th width="10%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center">
                      <b-img thumbnail fluid :src="url_base+item.image" alt="Image 1"></b-img>
                    </td>
                    <td class="text-left"> {{ item.title_es  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Inactivo</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('CoverPageEdit')" @click="EditCoverPage(item.id_cover_page)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('CoverPageView')" @click="ViewCoverPage(item.id_cover_page)" >Ver</b-dropdown-item>
                        <b-dropdown-item  v-if="Permission('CoverPageDelete')" @click="ConfirmDeleteCoverPage(item.id_cover_page)" >Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListCoverPage" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "UsuarioList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'CoverPage',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      search: "",
    };
  },
  mounted() {
    this.ListCoverPage();
  },
  methods: {
    ListCoverPage,
    EditCoverPage,
    ViewCoverPage,
    ConfirmDeleteCoverPage,
    DeleteCoverPage,
    Permission,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function ListCoverPage() {

  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url = this.url_base + "covers-page/list/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditCoverPage(id_cover_page) {
  this.$router.push({
    name: "CoverPageEdit",
    params: { id_cover_page: je.encrypt(parseInt(id_cover_page)) },
  });
}

// Ver Usuario
function ViewCoverPage(id_cover_page) {
  this.$router.push({
    name: "CoverPageView",
    params: { id_cover_page: je.encrypt(parseInt(id_cover_page)) },
  });
}

// Confirmar eliminar
function ConfirmDeleteCoverPage(id_cover_page) {
  Swal.fire({
    title: "Esta seguro de eliminar la portada?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteCoverPage(id_cover_page);
    }
  });
}

// eliminar usuario
function DeleteCoverPage(id_cover_page) {
  let me = this;
  let url = this.url_base + "covers-page/delete/" + id_cover_page;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_cover_page).indexOf(response.data.result.id_cover_page);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
